import { render } from "./RegistrationAgencyInfo.vue?vue&type=template&id=24d469ac&scoped=true&lang=pug"
import script from "./RegistrationAgencyInfo.vue?vue&type=script&lang=js"
export * from "./RegistrationAgencyInfo.vue?vue&type=script&lang=js"

import "./RegistrationAgencyInfo.vue?vue&type=style&index=0&id=24d469ac&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d469ac"]])

export default __exports__